<template>
    <div>
        <section>
            <div class="inner row5">
                <article class="infoInner">
                    <AdminUsrProfile />
                </article>
            </div>
        </section> 

    </div>   
</template>

<script>
import AdminUsrProfile from "@/components/join/admin/AdminUsrProfile"

export default {
    name: 'UserProfile',
    components: {
        AdminUsrProfile
    },
    data(){
        return {
        }
    },
    methods:{
    }
}
</script>

